import React from 'react';
import { ReactComponent as Setting } from '../../assets/images/icons/setting.svg';

export default function SettingIcon(props) {
  return (
    <Setting className={`icon ${props.className}`} />
  );
}
